import { useRef, useState } from 'react';
import FJLocalStore from '../../../../../store/FJLocalStore';
import styles from './FJFake3dAnimationItem.module.less';
import PropTypes from 'prop-types';
import FJConfig from '../../../../../config/FJConfig';
import FJUtil from '../../../../../util/FJUtil';
import ReloadIcon from '../../../../../assets/svg/reload.svg?react';
import FJHoverBoardGradation from '../../../../../common/components/FJHoverBoard/FJHoverBoardGradation';

const getSrc = imgName => {
    return FJConfig.imgPath + 'fake3d/style/' + imgName;
};
const FJFake3dAnimationItem = props => {
    const videoRef = useRef(null);
    const { selected, onClick, item = {} } = props;
    const [stateVideoUrl, setStateVideoUrl] = useState(getSrc(item.src));
    const [stateIsLoadError, setStateIsLoadError] = useState(false);
    /**
     * @private
     */
    const _refresh = e => {
        e.stopPropagation();
        setStateIsLoadError(false);
        setStateVideoUrl(FJUtil.getReloadNewUrl(getSrc(item.src)));
    };
    const _sourceLoaded = () => {
        setStateIsLoadError(false);
    };
    const _sourceError = () => {
        setStateIsLoadError(true);
    };

    const _onPlay = () => {
        videoRef.current && videoRef.current.play();
    };
    const _onPause = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    };

    return (
        <FJHoverBoardGradation
            onClick={onClick}
            className={styles.animation_item}
            active={selected}
            onMouseEnter={_onPlay}
            onMouseLeave={_onPause}
            isShowInBorder={true}
        >
            <video
                className={styles.animation_video}
                src={stateVideoUrl}
                muted
                loop
                ref={videoRef}
                onLoadStart={_sourceLoaded}
                onError={_sourceError}
            />
            <div className={styles.animation_text}>{FJLocalStore._(item.name)}</div>
            {stateIsLoadError && (
                <div className={styles.reload}>
                    <ReloadIcon onClick={_refresh} />
                </div>
            )}
        </FJHoverBoardGradation>
    );
};

FJFake3dAnimationItem.propTypes = {
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    item: PropTypes.object,
};

export default FJFake3dAnimationItem;
